import axios from '@/config/httpConfig'

// 标情发现跳转地址获取接口
export function queryUrl() {
  return axios.post('/biaoqing/queryUrl')
}
